export default "__VITE_ASSET__BRAyMy4d__"